define.alias("shared/components/shared/social/refresh-profile-list", "media/components/shared/social/refresh-profile-list");